import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { giftClient } from '@modules/Gift/client/giftClient';
import { cacheKeys } from '../config';


export const useGiftCrud = () => {
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createGift = useMutation({
    mutationKey: [cacheKeys.createGift],
    mutationFn: giftClient.createGift,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getGifts],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const editGift = useMutation({
    mutationKey: [cacheKeys.editGift],
    mutationFn: giftClient.editGift,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getGift, data.data.id],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createGift,
    editGift,
  };
};
